import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const FlowTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();
    const data = rows.filter(row => row.Category === "FLOW");
    return <EconomicTable data={data} title="Flow Analysis" defaultRowData={{ Category: "FLOW", Topic: "ETF Flows" }} groupBy="Topic" groupOrder={["ETF Flows", "Global Fund Flows", "Options Sentiment", "Futures Volume & OI"]} useDataHook={useMarketInternalsData} />;
};

export default FlowTab;
